import Vue from 'vue'
import App from './App.vue'
import i18n from './i18n'

import auth from '@/auth/authService.js'

// Vuesax Component Framework
import Vuesax from 'vuesax'
import 'material-icons/iconfont/material-icons.css' //Material Icons
import 'vuesax/dist/vuesax.css' // Vuesax
Vue.use(Vuesax)

// Moment
import Moment from 'moment'
import { extendMoment } from 'moment-range'
extendMoment(Moment)

// money
import money from 'v-money'
Vue.use(money, {precision: 4})

// API Calls
// import './http/requests'

// Theme Configurations
import '../themeConfig.js'
import Constant from '@/js/constant.js'

// ACL
import acl from './acl/acl'


// Globally Registered Components
import './globalComponents.js'

// Auth0 Plugin
// import AuthPlugin from './plugins/auth'
// Vue.use(AuthPlugin)

// Styles: CSS
import './assets/css/vendor/bootstrap.min.css'
import './assets/css/plugins/swiper.min.css'
import './assets/css/style.css'

// Styles: SCSS
import './assets/scss/main.scss'

// Tailwind
import './assets/css/main.css'


// Vue Router
import router from './router'

// Vuex Store
import store from './store/store'

// VeeValidate
import VeeValidate from 'vee-validate'
Vue.use(VeeValidate)

import Vue2Filters from 'vue2-filters'
Vue.use(Vue2Filters)

// Vuejs - Vue wrapper for hammerjs
import { VueHammer } from 'vue2-hammer'
Vue.use(VueHammer)

// Feather font icon
require('./assets/css/iconfont.css')


// axios
Vue.config.productionTip = false
import axios from 'axios'

axios.defaults.baseURL = Constant.hosts.url
axios.defaults.timeout = 18000000
axios.defaults.maxContentLength = 200000000
axios.defaults.maxBodyLength = 200000000

axios.interceptors.request.use(
  config => {
    const token = localStorage.getItem('access_token')
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`
    }
    config.data = JSON.stringify(config.data)
    config.headers['Content-Type'] = 'application/json'
    return config
  },
  error => {
    Promise.reject(error)
  })
//Add a response interceptor

Vue.filter('toCurrency', function (value) {
  if (typeof value !== 'number') {
    return value
  }
  const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0
  })
  return formatter.format(value)
})

axios.interceptors.response.use((response) => {
  return response
}, function (error) {
  if (error.response.status === 401) {
    auth.logOut()
    router.push('/home').catch(() => {})
    return Promise.reject(error)
  }

  return Promise.reject(error)
})
   
router.beforeEach(function (to, from, next) {
  const profile = JSON.parse(localStorage.getItem('user_roles'))
  if (auth.isAuthenticated() && (to.path === '/pages/login' || to.path === '/pages/forgot-password' || to.path === '/pages/reset-password')) {
    document.body.className = 'nav-md'
    if (profile.type !== 'Main-Admin') {
      next({ path: '/prospects' })
    } else {
      next({ path: '/prospects' })
    }
  } else if (!auth.isAuthenticated() && (to.path === '/pages/login'  || to.path === '/contact-us' || to.path === '/apply-for-rental' || to.path === '/find-a-rental' || to.path.includes('/home-for-rent/') || to.path === '/testimonials' || to.path === '/about-us' || to.path === '/tenant-resources' || to.path === '/home' || to.path === '/property-management' || to.path.includes('/pages/admin-login/') || to.path === '/pages/forgot-password' || to.path.includes('/pages/reset-password/'))) {
    next()
  } else if (!auth.isAuthenticated() && (to.path !== '/pages/login'  || to.path !== '/contact-us' || to.path !== '/apply-for-rental' || to.path !== '/find-a-rental' || !to.path.includes('/home-for-rent/') || to.path !== '/testimonials' || to.path !== '/about-us' || to.path !== '/tenant-resources' || to.path !== '/home' || to.path !== '/property-management' || !to.path.includes('/pages/admin-login/') || to.path !== '/pages/forgot-password' || !to.path.includes('/pages/reset-password/'))) {
    next({ path: '/home' })
  } else if (profile.type === 'Main-Admin') {
    if (!to.fullPath.includes('prospects')) {
      next({ path: '/prospects' })
    } else {
      next()
    }
  } else {
    next()
  }
})

new Vue({  
  i18n,
  acl,
  store,
  router,
  render: h => h(App)
}).$mount('#app')
